import { mapGetters } from 'vuex'
import { noExtendSessionPaths } from '@/utils/regex'

export default {
  computed: {
    ...mapGetters('user', ['currentUser']),
    showLoggedInContent () {
      return !(Object.values(noExtendSessionPaths).some(path => path.test(this.$route.path))) && Object.keys(this.currentUser).length > 0
    },
  },
}
